import { AlertTriangle, Phone } from "lucide-react";
import { COMPANY, waLink } from "@/lib/constants";

export const Urgency = () => {
  return (
    <section
      id="urgencia"
      data-testid="urgency-section"
      className="relative overflow-hidden bg-[#d90429]"
    >
      {/* Texture overlays */}
      <div className="absolute inset-0 grid-bg opacity-30 mix-blend-overlay"></div>
      <div className="absolute top-0 left-0 right-0 h-1 siren-stripe"></div>
      <div className="absolute bottom-0 left-0 right-0 h-1 siren-stripe"></div>

      {/* Giant ghost text */}
      <div className="absolute inset-0 flex items-center justify-center overflow-hidden pointer-events-none">
        <div className="font-display uppercase font-bold text-white/5 text-[22vw] md:text-[16vw] tracking-tighter whitespace-nowrap select-none leading-none">
          SOS 24H
        </div>
      </div>

      <div className="container-custom relative z-10 py-20 md:py-28 text-center">
        <div className="inline-flex items-center gap-3 bg-black/40 backdrop-blur-sm px-5 py-2.5 mb-6 border border-white/20">
          <span className="relative flex h-3 w-3">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
            <span className="relative inline-flex rounded-full h-3 w-3 bg-white"></span>
          </span>
          <AlertTriangle className="w-4 h-4 text-white" />
          <span className="overline text-white">Emergência Ativa 24/7</span>
        </div>

        <h2
          data-testid="urgency-headline"
          className="font-display uppercase font-bold text-white text-5xl sm:text-6xl md:text-7xl leading-[0.9] tracking-tight max-w-4xl mx-auto"
        >
          Precisou de guincho{" "}
          <span className="block md:inline">agora?</span>
        </h2>

        <p className="mt-6 text-white/90 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
          Atendimento rápido para emergências, panes e acidentes em Ribeirão
          Preto e região. Chegamos até você em minutos.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href={waLink("URGENTE! Preciso de guincho agora em Ribeirão Preto.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="urgency-whatsapp-cta"
            className="inline-flex items-center justify-center gap-3 bg-white text-[#d90429] font-display uppercase tracking-wider font-bold px-8 py-5 text-lg rounded-full pulse-red hover:bg-black hover:text-white transition-colors"
          >
            <i className="fa-brands fa-whatsapp text-2xl" aria-hidden></i>
            Solicitar Atendimento Imediato
          </a>
          <a
            href={`tel:${COMPANY.phoneTel}`}
            data-testid="urgency-phone-cta"
            className="inline-flex items-center gap-3 border-2 border-white text-white font-display uppercase tracking-wider font-bold px-8 py-5 text-lg hover:bg-white hover:text-[#d90429] transition-colors"
          >
            <Phone className="w-5 h-5" />
            {COMPANY.phoneDisplay}
          </a>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-x-8 gap-y-2 text-white/80 text-sm font-display uppercase tracking-widest">
          <span>✓ Resposta em minutos</span>
          <span>✓ Frota própria</span>
          <span>✓ Sem custo na orçamento</span>
        </div>
      </div>
    </section>
  );
};
